// AITC Image Overrides
// This file contains ONLY the images that should be different for AITC theme
// All other images will inherit from the default images

// Intro - Welcome Screen
import IMG_AITC from 'images/aiBlurImages/ai_blur_logo.svg';

// Intro -- Timeline Images
import IMG_INTRO_TL_ADVISOR_JOINS from 'images/aiBlurImages/intro/advisor_joins.png';
import IMG_INTRO_TL_ROLLED_OUT from 'images/aiBlurImages/intro/rolled_out.png';
import IMG_INTRO_TL_MISS_TARGET from 'images/aiBlurImages/intro/miss_target.png';
import IMG_INTRO_TL_TEAM_EXPAND from 'images/aiBlurImages/intro/team_expand.png';
import IMG_INTRO_TL_INITIATE_CHANGE from 'images/aiBlurImages/intro/initiate_change.png';
import IMG_INTRO_ROLE from 'images/aiBlurImages/intro/ai_blur_introRole.svg';

// Add any AITC specific image overrides here
const aitcImageOverrides = {
    IMG_AITC,

    IMG_INTRO_TL_ADVISOR_JOINS,
    IMG_INTRO_TL_ROLLED_OUT,
    IMG_INTRO_TL_MISS_TARGET,
    IMG_INTRO_TL_TEAM_EXPAND,
    IMG_INTRO_TL_INITIATE_CHANGE,

    IMG_INTRO_ROLE
};

export default aitcImageOverrides;
